import React from 'react';
import PropTypes from 'prop-types';
import styles from './BankCard.module.scss';

const BankCard = ({ logo, altText }) => (
  <div className={styles.card}>
    <img src={logo} alt={altText} />
  </div>
);

BankCard.propTypes = {
  logo: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
};

export default BankCard;
